export const ZODIAC_SIGNS = [
  {
    name: "Áries",
    prediction: "Hoje é um dia especial para iniciar novos projetos. A Lua em harmonia com Júpiter traz oportunidades únicas.",
    luckyNumber: 7,
    date: "21/03 - 20/04"
  },
  {
    name: "Touro",
    prediction: "Momento favorável para questões financeiras. Vênus traz estabilidade e boas oportunidades de crescimento.",
    luckyNumber: 4,
    date: "21/04 - 20/05"
  },
  {
    name: "Gêmeos",
    prediction: "Sua comunicação está em alta hoje. Mercúrio favorece novos contatos e aprendizados importantes.",
    luckyNumber: 3,
    date: "21/05 - 20/06"
  },
  {
    name: "Câncer",
    prediction: "A Lua, seu regente, traz intuição aguçada. Confie em seus instintos para tomar decisões.",
    luckyNumber: 2,
    date: "21/06 - 22/07"
  },
  {
    name: "Leão",
    prediction: "O Sol ilumina seu caminho hoje. Ótimo momento para brilhar e mostrar seus talentos.",
    luckyNumber: 1,
    date: "23/07 - 22/08"
  },
  {
    name: "Virgem",
    prediction: "Mercúrio favorece a organização e o planejamento. Aproveite para colocar as ideias em ordem.",
    luckyNumber: 5,
    date: "23/08 - 22/09"
  },
  {
    name: "Libra",
    prediction: "Vênus traz harmonia para seus relacionamentos. Momento ideal para parcerias e acordos.",
    luckyNumber: 6,
    date: "23/09 - 22/10"
  },
  {
    name: "Escorpião",
    prediction: "Plutão intensifica suas emoções. Use essa energia para transformações positivas.",
    luckyNumber: 8,
    date: "23/10 - 21/11"
  },
  {
    name: "Sagitário",
    prediction: "Júpiter expande seus horizontes. Ótimo momento para estudos e viagens.",
    luckyNumber: 9,
    date: "22/11 - 21/12"
  },
  {
    name: "Capricórnio",
    prediction: "Saturno traz foco e determinação. Concentre-se em suas metas principais.",
    luckyNumber: 10,
    date: "22/12 - 19/01"
  },
  {
    name: "Aquário",
    prediction: "Urano traz insights inovadores. Momento propício para mudanças e renovações.",
    luckyNumber: 11,
    date: "20/01 - 18/02"
  },
  {
    name: "Peixes",
    prediction: "Netuno aumenta sua sensibilidade e criatividade. Confie em sua intuição.",
    luckyNumber: 12,
    date: "19/02 - 20/03"
  }
] as const;